import * as React from "react";
import { SpsDateTime } from "@spscommerce/ds-react";
import { $CurrentUser } from "../../../classes/current.user/current.user";
import "./SpsNotificationRow.scss";

export default function SpsNotificationRow(props) {
  const { event, eventClickHandler } = props;
  const [interactedWith, setInteractedWith] = React.useState(
    event.interacted_at
  );
  const dotClass = !interactedWith
    ? "not-interacted-with notification-dot"
    : "interacted-with notification-dot";
  function handleEventClick() {
    if (eventClickHandler) {
      eventClickHandler(event).then(() => {
        if (event.link) {
          window.open(event.link, "_blank");
        }
      });
    }
    setInteractedWith(true);
  }

  function useFallbackImage(event) {
    event.target.src =
      "https://cdn.prod.spsc.io/web/framework/assets/19.05.01/icons/sps-logo/sps-logo.svg";
  }

  React.useEffect(() => {
    if (event && event.interacted_at) {
      setInteractedWith(true);
    }
  }, [event]);

  return (
    <div className="sps-notification-row" onClick={handleEventClick}>
      <i className={dotClass} />
      <img
        src={
          event.producer_icon ||
          "https://cdn.prod.spsc.io/web/framework/assets/19.05.01/icons/sps-logo/sps-logo.svg"
        }
        className="event-image sps-notification-drowdown__event-producer-icon"
        onError={useFallbackImage}
      />
      <div className="body-wrapper">
        <div className="event-body truncate-overflow">{event.body}</div>
        <div className="event-time">
          <SpsDateTime
            relativeHrs={24}
            currentUser={$CurrentUser}
            format="LONG_FULLDATETIME"
          >
            {event.created_at}
          </SpsDateTime>
        </div>
      </div>
    </div>
  );
}
